import { TaskStatus } from "@/features/assessments/features/utils";
import { useUserId } from "@/libs/auth";
import { UserRead } from "@/services/generatedApi";
import { Chip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface NeedsReviewProps {
  status: number;
  reviewers: UserRead[];
}
export const NeedsReview: React.FC<NeedsReviewProps> = ({ status, reviewers }) => {
  const { t } = useTranslation();
  const userId = useUserId();

  if (status !== TaskStatus.IN_REVIEW) {
    return null;
  }
  if (!reviewers.some(reviewer => reviewer.id === userId)) {
    return null;
  }

  return (
    <Chip
      sx={{
        borderRadius: "4px",
        fontSize: "10px",
        backgroundColor: "var(--primary-mint-300)",
        height: "24px",
        span: { px: "8px" },
      }}
      label={t("assessments.Needs_review")}
    />
  );
};
